// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","modal":"Modal_modal__RajTW","slide-down":"Modal_slide-down__tDgXQ"};